// Formatting shared by the profile cards and the resume builder, kept apart
// from the builder's helpers so a profile page does not load those.

/** A stored grade as it should read: "8.5 CGPA", "3.6 GPA", "85%".
 * `inferScale` gives a row saved before the scale was stored the old reading:
 * 10 and under is a grade point, more is a percentage. */
export const formatGradeText = (
  grade?: number | string | null,
  scale?: string | null,
  { inferScale = false }: { inferScale?: boolean } = {},
) => {
  if (grade === null || grade === undefined) return '';
  const text = String(grade).trim();
  // 0 is the profile form's placeholder, never a grade anyone was awarded.
  if (!text || Number(text) === 0) return '';
  if (scale === 'Percentage') return `${text}%`;
  if (scale === 'CGPA' || scale === 'GPA') return `${text} ${scale}`;
  if (inferScale && !scale) {
    return `${text}${Number(text) <= 10 ? ' SGPA' : '%'}`;
  }
  return text;
};

/** "B.Tech, Computer Science" -- the specialization beside the degree, unless
 * the degree already says it ("B.E. in Electronics", "Electronics"). */
export const formatDegreeTitle = (
  degree?: string | null,
  specialization?: string | null,
) => {
  const name = (degree ?? '').trim();
  const field = (specialization ?? '').trim();
  if (!field || name.toLowerCase().includes(field.toLowerCase())) return name;
  return name ? `${name}, ${field}` : field;
};
